import { createStandardAction } from 'typesafe-actions';

const EXPORT_ALL_PAGES_TO_FILE = 'EXPORT_ALL_PAGES_TO_FILE';

const IMPORT_PAGES_FROM_FILE = 'IMPORT_PAGES_FROM_FILE';
const IMPORT_PAGES_FROM_750_WORDS = 'IMPORT_PAGES_FROM_750_WORDS';
const IMPORT_PAGES_FROM_DAY_ONE = 'IMPORT_PAGES_FROM_DAY_ONE';
const IMPORT_PAGES_FROM_FILE_ERROR = 'IMPORT_PAGES_FROM_FILE_ERROR';

const IMPORT_PAGES_FROM_FILE_FILE_READ_SUCCESS = 'IMPORT_PAGES_FROM_FILE_FILE_READ_SUCCESS';
const IMPORT_PAGES_FROM_FILE_FILE_READ_ERROR = 'IMPORT_PAGES_FROM_FILE_FILE_READ_ERROR';

export const exportAllPagesToFile = createStandardAction(EXPORT_ALL_PAGES_TO_FILE)();

export const importPagesFromFile = createStandardAction(IMPORT_PAGES_FROM_FILE)<any>();
export const importPagesFrom750Words = createStandardAction(IMPORT_PAGES_FROM_750_WORDS)<any>();
export const importPagesFromDayOne = createStandardAction(IMPORT_PAGES_FROM_DAY_ONE)<any>();
export const importPagesFromFileError = createStandardAction(IMPORT_PAGES_FROM_FILE_ERROR)<Error>();

export const importPagesFromFileFileReadSuccess = createStandardAction(IMPORT_PAGES_FROM_FILE_FILE_READ_SUCCESS)<any>();
export const importPagesFromFileFileReadError = createStandardAction(IMPORT_PAGES_FROM_FILE_FILE_READ_ERROR)<any>();



// WEBPACK FOOTER //
// ./src/modules/importExport/actions.ts